import { useEffect, useRef, useState } from 'react';
import { RACHEL_LIST_SCOPE } from '../effects/uiEffect.schema';
import { useRachelEventListener } from '../effects/useRachelEventListener';
import { RACHEL_EFFECT_MS, useRachelAddedRowsStyles } from '../styles/rachelEffects.styles';
import { GetRowIdsAddedOnTopParams, UseRachelListPageSyncParams } from './rachelEffects.types';

const RELOAD_GRACE_MS = 1000;

const getRowIdsAddedOnTop = ({ previousRowIds, rowIds }: GetRowIdsAddedOnTopParams) => {
  const knownRowIds = new Set(previousRowIds);
  const firstKnownIndex = rowIds.findIndex((rowId) => knownRowIds.has(rowId));

  return firstKnownIndex === -1 ? [] : rowIds.slice(0, firstKnownIndex);
};

export const useRachelListPageSync = ({
  resource,
  rowIds,
  reload,
  onChange,
}: UseRachelListPageSyncParams) => {
  const [rowIdsBeforeChange, setRowIdsBeforeChange] = useState<string[] | null>(null);
  const highlightTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(highlightTimeoutRef.current), []);

  useRachelEventListener({
    resource,
    scopeId: RACHEL_LIST_SCOPE,
    onChange: (event) => {
      setRowIdsBeforeChange(rowIds);
      clearTimeout(highlightTimeoutRef.current);
      highlightTimeoutRef.current = setTimeout(
        () => setRowIdsBeforeChange(null),
        RACHEL_EFFECT_MS.highlight + RELOAD_GRACE_MS,
      );
      reload();
      onChange?.(event);
    },
  });

  const addedRowIds = rowIdsBeforeChange
    ? getRowIdsAddedOnTop({ previousRowIds: rowIdsBeforeChange, rowIds })
    : [];

  const { classes } = useRachelAddedRowsStyles({ rowIds: addedRowIds });

  return { rachelRowsClassName: classes.rows };
};
